
import {
  computed, defineComponent, PropType,
} from '@vue/composition-api';
import FCImage from '~/components/FCImage.vue';
import { IPackageProperties } from '~/types/fightcamp';

export default defineComponent({
  name: 'PackageBuilderCard',
  components: {
    FCImage,
  },
  props: {
    product: {
      type: Object as PropType<IPackageProperties>,
      required: true,
    },
    isActive: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    isRecommended: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  setup(props) {
    const transformedPackageData = computed(() => ({
      productName: props.product.productName,
      price: props.product.price,
      oldPrice: props.product.oldPrice,
      bulletPoints: props.product?.description.replace(/\n/g, ' ').split(/(?=\d\s)/),
      lifestyleImage: {
        src: props.product.assets[1].src,
        alt: 'gloves',
      },
    }));

    return {
      transformedPackageData,
    };
  },
});
